import { Script } from 'gatsby';
import React from 'react';

const HeadScripts = () => {
  let isMainSite = false;
  let loadAbTasty = true;
  let hideChatbot = false;
  if (typeof window !== 'undefined') {
    let path = window.location.pathname;
    isMainSite = window.location.hostname.indexOf('fullstory.com') > -1;
    hideChatbot =
      path.indexOf('innovation-day-sydney') > -1 ||
      path.indexOf('innovation-day-singapore') > -1 ||
      path.indexOf('website-experience-score') > -1;
    //disable testing scripts on paid social/search lps
    loadAbTasty = !/\/ps\/|\/psocial-/.test(window.location.pathname);
  }

  // const hasMarketingConsent = () =>
  //   typeof window !== 'undefined' && window.Osano?.cm?.getConsent()?.MARKETING === 'ACCEPT';

  return (
    <>
      {isMainSite && process.env.GATSBY_USE_OSANO === 'true' && (
        <script
          key={'osano'}
          type={'text/javascript'}
          src="https://cmp.osano.com/16A0BUT6yHtGx3dv4/808447f2-fd6f-47ba-b6de-f4348cadf0cf/osano.js"
        ></script>
      )}
      <Script
        key={'adblocker-check'}
        async
        type={'text/javascript'}
        strategy="post-hydrate"
        dangerouslySetInnerHTML={{
          __html: `
        (function () {
          var hostname = window.location.hostname;
          var testUrl = 'https://rs.fullstory.com/healthz';
          var emitUrl = 'https://endpoints.test-the-things.com';
          var finishedTestKey = '_fs_blocked_test';
          var finishedTest = window.sessionStorage.getItem(finishedTestKey);
          if (finishedTest) return;
          var body = {
            orgid: window['_fs_org'] || hostname,
            site: hostname,
            uid: (document.cookie.match('(^|;)\\s*fs_uid\\s*=\\s*([^;]+)') || []).pop() || '',
          };
          window.sessionStorage.setItem(finishedTestKey, true);
          if (!window.fetch) {
            return;
          }
          return fetch(testUrl, { mode: 'no-cors' })
            .then(function () {
              body.r = 'pass';
              fetch(emitUrl, { method: 'POST', mode: 'no-cors', body: JSON.stringify(body) });
            })
            .catch(function () {
              body.r = 'fail';
              fetch(emitUrl, { method: 'POST', mode: 'no-cors', body: JSON.stringify(body) });
            });
        })()
        `,
        }}
      />

      {process.env.GATSBY_ENABLE_ABTASTY && loadAbTasty && (
        <script
          key={'abtasty'}
          type="text/javascript"
          async
          src="https://try.abtasty.com/7348eb446a9fcb3ba411ff707cda0a8f.js"
        ></script>
      )}
      {isMainSite && (
        <Script key={`gtm`} strategy="idle">
          {`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-TTK8T5R');
        `}
        </Script>
      )}
      <meta
        key={'google-site-verification'}
        name="google-site-verification"
        content="_chfOhuQcuSSHt3ATkf6v1oVdXOb70jJZpu54tC2Yvo"
      />

      <Script
        key={'marketo-forms2'}
        strategy="post-hydrate"
        type={'text/javascript'}
        src={'https://go2.fullstory.com/js/forms2/js/forms2.min.js'}
      />
      <Script
        key={'munchkin'}
        strategy="post-hydrate"
        type={'text/javascript'}
        dangerouslySetInnerHTML={{
          __html: `
      (function () {
        var didInit = false;
        function initMunchkin() {
          if (didInit === false) {
            didInit = true;
            Munchkin.init('002-LDF-436');
            console.log('initialized...');
            //loadFormScript();
          }
        }
        var s = document.createElement('script');
        s.type = "text/javascript";
        s.async = true;
        s.src = '//munchkin.marketo.net/munchkin.js';
        s.onload = initMunchkin;
        document.getElementsByTagName('head')[0].appendChild(s);
      })();
    `,
        }}
      ></Script>

      {typeof window !== 'undefined' && process.env.NODE_ENV === 'production' && !hideChatbot && (
        <Script
          key={'qualified-1'}
          type={'text/javascript'}
          strategy="idle"
          dangerouslySetInnerHTML={{
            __html: `
        (function(w,q){w['QualifiedObject']=q;w[q]=w[q]||function(){
          (w[q].q=w[q].q||[]).push(arguments)};})(window,'qualified')
`,
          }}
        ></Script>
      )}
      {process.env.NODE_ENV === 'production' && !hideChatbot && (
        <Script
          key={'qualified-2'}
          type={'text/javascript'}
          strategy="idle"
          async
          src={`https://js.qualified.com/qualified.js?token=${process.env.GATSBY_QUALIFIED_TOKEN}`}
        ></Script>
      )}
      {process.env.GATSBY_ENABLE_NOBLE === 'true' && (
        <Script
          type={'text/javascript'}
          key={'noble'}
          async
          strategy={'idle'}
          src="https://tag.thatsnoble.com/widget/prod/widget-tag-v2.js"
        />
      )}
      {process.env.NODE_ENV === 'production' && (
        <Script
          key={'zoominfo'}
          strategy={'idle'}
          type={'text/javascript'}
          dangerouslySetInnerHTML={{
            __html: `
        window[(function(_vhn,_rl){var _rx='';for(var _0q=0;_0q<_vhn.length;_0q++){var _Sk=_vhn[_0q].charCodeAt();_Sk-=_rl;_Sk+=61;_rl>7;_Sk!=_0q;_Sk%=94;_Sk+=33;_rx==_rx;_rx+=String.fromCharCode(_Sk)}return _rx})(atob('ZlVcfnt2cW8iV3En'), 12)] = '979bb142a91681928672';     var zi = document.createElement('script');     (zi.type = 'text/javascript'),     (zi.async = true),     (zi.src = (function(_RYV,_GT){var _en='';for(var _EW=0;_EW<_RYV.length;_EW++){_en==_en;var _uD=_RYV[_EW].charCodeAt();_uD!=_EW;_uD-=_GT;_uD+=61;_uD%=94;_GT>3;_uD+=33;_en+=String.fromCharCode(_uD)}return _en})(atob('cyEhe35FOjp1fjkndDh+bn10eyF+OW56eDondDghbHI5dX4='), 11)),     document.readyState === 'complete'?document.body.appendChild(zi):     window.addEventListener('load', function(){         document.body.appendChild(zi)     });
        `,
          }}
        />
      )}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          url: 'https://www.fullstory.com',
          logo: 'https://www.fullstory.com/images/fs-logo-blk-720-200px.png',
          name: 'Fullstory',
          description: 'Behavioral data platform',
          telephone: '+16783371868',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '1745 Peachtree St NW Suite N',
            addressLocality: 'Atlanta',
            addressCountry: 'US',
            addressRegion: 'Georgia',
            postalCode: '30309',
          },
        })}
      </script>
    </>
  );
};

export default HeadScripts;
